import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,CCol,
	CForm,CFormInput,CFormTextarea,CFormCheck,CFormSelect,
	CInputGroup,CInputGroupText,CButton,CFormLabel,CFormRange,
	CModal,CModalBody,CModalFooter,CModalHeader,
	CModalTitle,CCloseButton,
} from '@coreui/react';
import { isMobile } from "react-device-detect";
import CIcon from '@coreui/icons-react';
import { 
	MyButton,
	MyDialoglookup,
} from './index';
import { Konfirm } from '../helpers/onConfirm';
import { UFunc } from "../helpers/functions";

const pjson 	= require('../../package.json')
const MyDialogformobjective = props => {
	const { 
		showDlg, toggleShow, pasienDataObj, 
		showToast, setLoading, setSessionaktif, prosesExpired,
		...rest 
	} = props;

	const uDispatch 				= useDispatch();
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uDatainputObj 			= useSelector(state => state.gDataobjective) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");

	const [uEfekview,setEfekview] 		= React.useState(false);
	const [uDataformObj,setDataformObj] = React.useState({});
	const [uAgamaArr,setAgamaArr] 		= React.useState([]);
	const [uPekerjaanArr,setPekerjaanArr] = React.useState([]);

	//---DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]	= React.useState({});
	//---END DLG_LOOKUP--/

	const hdlKlikAgamalookup = () => {
		setDlglookupObj({
			dlg_headers: "Lookup: AGAMA",
			dlg_input: "",
			data_arr: uAgamaArr.map(vItems=>{ return {id:vItems.id,caption:vItems.nama_agama}}),
			jenis: "AGAMA",
		})
		setDlglookupshow(true);
	}
	const hdlKlikPekerjaanlookup = () => {
		setDlglookupObj({
			dlg_headers: "Lookup: PEKERJAAAN",
			dlg_input: "",
			data_arr: uPekerjaanArr.map(vItems=>{ return {id:vItems.id,caption:vItems.nama_pekerjaan}}),
			jenis: "PEKERJAAAN",
		})
		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM 	= parseInt(_IDITEM);

		let vArridx;
		let vElfocusnext;
		if(uDlglookupObj.jenis === "AGAMA") {
			vArridx	= UFunc.getObjectIndeks(uAgamaArr,_IDITEM);
			setDataformObj({...uDataformObj,
				sosial_agama_id: uAgamaArr[vArridx].id,
				sosial_agama: uAgamaArr[vArridx].nama_agama,
			});
			vElfocusnext = document.getElementById("inpsosialpendidikan")
		}
		else if(uDlglookupObj.jenis === "PEKERJAAAN") {
			vArridx	= UFunc.getObjectIndeks(uPekerjaanArr,_IDITEM);
			setDataformObj({...uDataformObj,
				sosial_pekerjaan_id: uPekerjaanArr[vArridx].id,
				sosial_pekerjaan: uPekerjaanArr[vArridx].nama_pekerjaan,
			});
			vElfocusnext = document.getElementById("inpriwayatkesehatan");
		}
		setDlglookupshow(false);	

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			if(!isMobile) vElfocusnext && vElfocusnext.focus()
		},400)
	}
	const hdlKlikSimpan = () => {
		//--VALIDASI--/
		const updatedObj = Object.fromEntries(
			Object.entries(uDataformObj).map(([key,value]) => {
				//console.log("key = "+key); console.log("value = "+value);
				return ([
					key,
					((value && typeof(value) === "string")
						? ((value||"").trim() === "" ? undefined : value)
						: ((parseInt(value)||0) <= 0 ? undefined : value)
					),
				])
			})
		);
		//--END VALIDASI--/

		uDispatch({type: "set", gDataobjective: updatedObj});
		uDispatch({type: "set", gISObjectivesimpan: true});
	}

	const contentMain = () => {
		return (
		<CForm>
		<div className="py-2 px-3 mb-3 border-top border-bottom fw-bolder">
		Screening Medis
		</div>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Tekanan Darah</span>
				<small className="d-md-none">Tekanan Darah</small>
			</CCol>
			<CCol xs="8" md="7" lg="4" className="">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number" min={0}
					className="text-end"
					value={uDataformObj.tekanandarahatas}
					onChange={(e)=>setDataformObj({...uDataformObj,tekanandarahatas:e.target.value})}
					id="inptekanandarahatas"/>
				<span className="mx-1">/</span>
				<CFormInput size="sm" type="number" min={0}
					className="text-end"
					value={uDataformObj.tekanandarahbawah}
					onChange={(e)=>setDataformObj({...uDataformObj,tekanandarahbawah:e.target.value})}
					id="inptekanandarahbawah"/>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Denyut Nadi</span>
				<small className="d-md-none">Denyut</small>
			</CCol>
			<CCol xs="8" md="3" className="">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number" min={0}
					className="text-end"
					value={uDataformObj.denyutnadi}
					onChange={(e)=>setDataformObj({...uDataformObj,denyutnadi:e.target.value})}
					id="inpdenyutnadi"/>
				<CInputGroupText>bit/m</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Suhu Badan</span>
				<small className="d-md-none">Suhu</small>
			</CCol>
			<CCol xs="8" md="3" lg="3" className="">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number" min={0} step={0.1}
					className="text-end"
					value={uDataformObj.suhu}
					onChange={(e)=>setDataformObj({...uDataformObj,suhu:e.target.value})}
					id="inpsuhu"/>
				<CInputGroupText>&deg; C</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Berat Badan</span>
				<small className="d-md-none">Berat</small>
			</CCol>
			<CCol xs="8" md="3" lg="3" className="">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number" min={0}
					className="text-end"
					value={uDataformObj.berat}
					onChange={(e)=>setDataformObj({...uDataformObj,berat:e.target.value})}
					id="inpberat"/>
				<CInputGroupText>KG</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>

		<div className="py-2 px-3 my-3 border-top border-bottom fw-bolder">
		KONDISI NYERI
		</div>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Status Nyeri</span>
				<small className="d-md-none">Status Nyeri</small>
			</CCol>
			<CCol xs="8" className="">
				<CInputGroup size="sm">
				<CInputGroupText style={{minWidth:90}} className="bg-transparent me-1">
				<input type="radio"
					value="TIDAK"
					className="me-2"
					checked={uDataformObj.nyeri_status === "TIDAK"}
					onChange={(e)=>setDataformObj({...uDataformObj,nyeri_status:e.target.value})}
					name="inpnyeristatus"
					id="inpnyeristatustidak"/>
				<label for="inpnyeristatustidak" className="d-inline-block fw-bolder classcursorpointer">TIDAK</label>
				</CInputGroupText>

				<CInputGroupText style={{minWidth:90}} className="bg-transparent me-1">
				<input type="radio"
					value="YA"
					className="me-2"
					checked={uDataformObj.nyeri_status === "YA"}
					onChange={(e)=>setDataformObj({...uDataformObj,nyeri_status:e.target.value})}
					name="inpnyeristatus"
					id="inpnyeristatusya"/>
				<label for="inpnyeristatusya" className="d-inline-block fw-bolder classcursorpointer">YA</label>
				</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>
		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Skala Nyeri</span>
				<small className="d-md-none">Skala Nyeri</small>
			</CCol>
			<CCol className="">
				<CFormRange size="sm" min={0} max={10} step={1}
					value={uDataformObj.nyeri_skala || 0}
					onChange={(e)=>setDataformObj({...uDataformObj,nyeri_skala:e.target.value})}
					label={"(Level "+(uDataformObj.nyeri_skala || 0)+")"} id="inpskalanyeri" />
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Kategori</span>
				<small className="d-md-none">Kategori</small>
			</CCol>
			<CCol className="">
				<CInputGroup size="sm">
				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="RINGAN"
					className="me-2"
					checked={uDataformObj.nyeri_kategori === "RINGAN"}
					onChange={(e)=>setDataformObj({...uDataformObj,nyeri_kategori:e.target.value})}
					name="inpnyerikategori"
					id="inpnyerikategoriringan"/>
				<label for="inpnyerikategoriringan" className="d-inline-block fw-bolder classcursorpointer">RINGAN</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="SEDANG"
					className="me-2"
					checked={uDataformObj.nyeri_kategori === "SEDANG"}
					onChange={(e)=>setDataformObj({...uDataformObj,nyeri_kategori:e.target.value})}
					name="inpnyerikategori"
					id="inpnyerikategorisedang"/>
				<label for="inpnyerikategorisedang" className="d-inline-block fw-bolder classcursorpointer">SEDANG</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="BERAT"
					className="me-2"
					checked={uDataformObj.nyeri_kategori === "BERAT"}
					onChange={(e)=>setDataformObj({...uDataformObj,nyeri_kategori:e.target.value})}
					name="inpnyerikategori"
					id="inpnyerikategoriberat"/>
				<label for="inpnyerikategoriberat" className="d-inline-block fw-bolder classcursorpointer">BERAT</label>
				</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>

		<div className="py-2 px-3 my-3 border-top border-bottom fw-bolder">
		STATUS MENTAL
		</div>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Emosi</span>
				<small className="d-md-none">Emosi</small>
			</CCol>
			<CCol className="">
				<CFormInput size="sm" maxLength={255}
					value={uDataformObj.mental_emosi}
					onChange={(e)=>setDataformObj({...uDataformObj,mental_emosi:e.target.value})}
					id="inpstatusemosi"/>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Konsep Diri</span>
				<small className="d-md-none">Konsep Diri</small>
			</CCol>
			<CCol className="">
				<CFormInput size="sm" maxLength={255}
					value={uDataformObj.mental_konsepdiri}
					onChange={(e)=>setDataformObj({...uDataformObj,mental_konsepdiri:e.target.value})}
					id="inpkonsepdiri"/>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Gaya Komunikasi</span>
				<small className="d-md-none">Komunikasi</small>
			</CCol>
			<CCol className="">
				<CFormInput size="sm" maxLength={255}
					value={uDataformObj.mental_komunikasi}
					onChange={(e)=>setDataformObj({...uDataformObj,mental_komunikasi:e.target.value})}
					id="inpkomunikasi"/>
			</CCol>
		</CRow>

		<div className="py-2 px-3 my-3 border-top border-bottom fw-bolder">
		STATUS PSIKOSOSIAL-SPIRITUAL
		</div>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Status Mental</span>
				<small className="d-md-none">Status Mental</small>
			</CCol>
			<CCol xs="8" className="">
				<CInputGroup size="sm">
				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="ORIENTASI BAIK"
					className="me-2"
					checked={uDataformObj.psiko_mental === "ORIENTASI BAIK"}
					onChange={(e)=>setDataformObj({...uDataformObj,psiko_mental:e.target.value})}
					name="inpmental"
					id="inpmentalbaik"/>
				<label for="inpmentalbaik" className="d-inline-block fw-bolder classcursorpointer">ORIENTASI BAIK</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="DIS ORIENTASI"
					className="me-2"
					checked={uDataformObj.psiko_mental === "DIS ORIENTASI"}
					onChange={(e)=>setDataformObj({...uDataformObj,psiko_mental:e.target.value})}
					name="inpmental"
					id="inpmentaldisorientasi"/>
				<label for="inpmentaldisorientasi" className="d-inline-block fw-bolder classcursorpointer">DIS-ORIENTASI</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="GELISAH"
					className="me-2"
					checked={uDataformObj.psiko_mental === "GELISAH"}
					onChange={(e)=>setDataformObj({...uDataformObj,psiko_mental:e.target.value})}
					name="inpmental"
					id="inpmentalgelisah"/>
				<label for="inpmentalgelisah" className="d-inline-block fw-bolder classcursorpointer">GELISAH</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="TIDAK RESPON"
					className="me-2"
					checked={uDataformObj.psiko_mental === "TIDAK RESPON"}
					onChange={(e)=>setDataformObj({...uDataformObj,psiko_mental:e.target.value})}
					name="inpmental"
					id="inpmentaltidakrespon"/>
				<label for="inpmentaltidakrespon" className="d-inline-block fw-bolder classcursorpointer">TIDAK RESPON</label>
				</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Respon Emosi</span>
				<small className="d-md-none">Respon Emosi</small>
			</CCol>
			<CCol xs="8" className="">
				<CInputGroup size="sm">
				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="TENANG"
					className="me-2"
					checked={uDataformObj.psiko_emosi === "TENANG"}
					onChange={(e)=>{uDataformObj.psiko_emosi=e.target.value;setEfekview(!uEfekview)}}
					name="inpemosi"
					id="inpemositenang"/>
				<label for="inpemositenang" className="d-inline-block fw-bolder classcursorpointer">TENANG</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="TAKUT"
					className="me-2"
					checked={uDataformObj.psiko_emosi === "TAKUT"}
					onChange={(e)=>{uDataformObj.psiko_emosi=e.target.value;setEfekview(!uEfekview)}}
					name="inpemosi"
					id="inpemositakut"/>
				<label for="inpemositakut" className="d-inline-block fw-bolder classcursorpointer">TAKUT</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="TEGANG"
					className="me-2"
					checked={uDataformObj.psiko_emosi === "TEGANG"}
					onChange={(e)=>{uDataformObj.psiko_emosi=e.target.value;setEfekview(!uEfekview)}}
					name="inpemosi"
					id="inpemositegang"/>
				<label for="inpemositegang" className="d-inline-block fw-bolder classcursorpointer">TEGANG</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="MARAH"
					className="me-2"
					checked={uDataformObj.psiko_emosi === "MARAH"}
					onChange={(e)=>{uDataformObj.psiko_emosi=e.target.value;setEfekview(!uEfekview)}}
					name="inpemosi"
					id="inpemosimarah"/>
				<label for="inpemosimarah" className="d-inline-block fw-bolder classcursorpointer">MARAH</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="SEDIH"
					className="me-2"
					checked={uDataformObj.psiko_emosi === "SEDIH"}
					onChange={(e)=>{uDataformObj.psiko_emosi=e.target.value;setEfekview(!uEfekview)}}
					name="inpemosi"
					id="inpemosisedih"/>
				<label for="inpemosisedih" className="d-inline-block fw-bolder classcursorpointer">SEDIH</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="MENANGIS"
					className="me-2"
					checked={uDataformObj.psiko_emosi === "MENANGIS"}
					onChange={(e)=>{uDataformObj.psiko_emosi=e.target.value;setEfekview(!uEfekview)}}
					name="inpemosi"
					id="inpemosimenangis"/>
				<label for="inpemosimenangis" className="d-inline-block fw-bolder classcursorpointer">MENANGIS</label>
				</CInputGroupText>

				<CInputGroupText className="bg-transparent me-1 mb-1">
				<input type="radio"
					value="GELISAH"
					className="me-2"
					checked={uDataformObj.psiko_emosi === "GELISAH"}
					onChange={(e)=>{uDataformObj.psiko_emosi=e.target.value;setEfekview(!uEfekview)}}
					name="inpemosi"
					id="inpemosigelisah"/>
				<label for="inpemosigelisah" className="d-inline-block fw-bolder classcursorpointer">GELISAH</label>
				</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>

		<div className="py-2 px-3 my-3 border-top border-bottom fw-bolder">
		SOSIAL BUDAYA
		</div>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Agama</span>
				<small className="d-md-none">Agama</small>
			</CCol>
			<CCol className="">
				<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					placeholder="--Pilih Agama Pasien"
					value={uDataformObj.sosial_agama||""}
					onClick={()=>hdlKlikAgamalookup()}
					id="inpsosialagama"/>
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikAgamalookup()}
					id="btnSosialagamalookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Pendidikan Terakhir</span>
				<small className="d-md-none">Pendidikan</small>
			</CCol>
			<CCol className="">
				<CFormInput size="sm" maxLength={100}
					value={uDataformObj.sosial_pendidikan||""}
					onChange={(e)=>setDataformObj({...uDataformObj,sosial_pendidikan:e.target.value})}
					id="inpsosialpendidikan"/>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Pekerjaan</span>
				<small className="d-md-none">Pekerjaan</small>
			</CCol>
			<CCol className="">
				<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					placeholder="--Pilih Pekerjaan Pasien"
					value={uDataformObj.sosial_pekerjaan||""}
					onClick={()=>hdlKlikPekerjaanlookup()}
					id="inpsosialpekerjaan"/>
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikPekerjaanlookup()}
					id="btnSosialpekerjaanlookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
		</CRow>

		<div className="py-2 px-3 my-3 border-top border-bottom fw-bolder">
		LAINNYA
		</div>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end pe-0 pe-md-3">
				<span className="d-none d-md-block">Riwayat Kesehatan</span>
				<small className="d-md-none">Rwyt Kesehatan</small>
			</CCol>
			<CCol className="">
				<CFormInput size="sm" maxLength={100}
					value={uDataformObj.riwayat_kesehatan}
					onChange={(e)=>setDataformObj({...uDataformObj,riwayat_kesehatan:e.target.value})}
					id="inpriwayatkesehatan"/>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Riwayat <span className="me-1 d-none d-lg-inline">Penggunaan</span>Obat</span>
				<small className="d-md-none">Riwayat Obat</small>
			</CCol>
			<CCol className="">
				<CFormInput size="sm" maxLength={100}
					value={uDataformObj.riwayat_obat}
					onChange={(e)=>setDataformObj({...uDataformObj,riwayat_obat:e.target.value})}
					id="inpriwayatobat"/>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-lg-0">
			<CCol xs="4" className="text-md-end">
				<span className="d-none d-md-block">Screening Gizi</span>
				<small className="d-md-none">Screening Gizi</small>
			</CCol>
			<CCol className="">
				<CFormInput size="sm" maxLength={100}
					value={uDataformObj.riwayat_gizi}
					onChange={(e)=>setDataformObj({...uDataformObj,riwayat_gizi:e.target.value})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpscreeninggizi"/>
			</CCol>
		</CRow>
		</CForm>
		)//>
	}

	const apiLoadinit = () => {
		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});

		const vHeaderObj = {
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}
		setLoading(true);
		Promise.all([
			fetch(pjson.homepage+"api/api_agama/ld_masteragama",vHeaderObj).
			then(response => {
				if (!response.ok) throw new Error('Network response 1 was not ok.');
				setSessionaktif(false);
				return response.json();
			}),
			fetch(pjson.homepage+"api/api_pekerjaan/ld_masterpekerjaan",vHeaderObj).
			then(response => {
				if (!response.ok) throw new Error('Network response 2 was not ok.');

				setSessionaktif(false);
				return response.json();
			}),
      ]).
		then(([output_agama, output_pekerjaan]) => { 
			setSessionaktif(true);
			if(output_agama.tampil) {
				setAgamaArr(JSON.parse(output_agama.datamaster||"[]"));
			} else if(output_agama.info) {
				showToast(output_agama.info);
			} else if(output_agama.errors) {
				console.log("(MyDialogformobjective - apiLoadinit) output_agama.errors : "+output_agama.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_agama.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_agama.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(output_pekerjaan.tampil) {
				setPekerjaanArr(JSON.parse(output_pekerjaan.datamaster||"[]"));
			} else if(output_pekerjaan.info) {
				showToast(output_pekerjaan.info);
			} else if(output_pekerjaan.errors) {
				console.log("(MyDialogformobjective - apiLoadinit) output_pekerjaan.errors : "+output_pekerjaan.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_pekerjaan.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_pekerjaan.expired) {
				setLoading(true); prosesExpired(); return;
			}
		}).
		catch(error => { 
			console.log("(MyDialogformobjective - apiLoadinit) catch-error : "+error.message);
			showToast(error.message,"ERROR");
		}).
		finally(() => {
			setLoading(false);
		});
	}

	React.useEffect(()=>{
		apiLoadinit();

		return ()=>{
			setDataformObj({});toggleShow();setDlglookupshow(false);
			setAgamaArr([]);setPekerjaanArr([]);
		}
	},[])
	React.useEffect(()=>{
		if(!showDlg) { 
			setDataformObj({}); return;
		}

		if(uAgamaArr.length <= 0 || uPekerjaanArr.length <= 0) {
			apiLoadinit();
		}

		setDataformObj(uDatainputObj);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			if(!isMobile)
				document.getElementById("inptekanandarahatas") &&
					document.getElementById("inptekanandarahatas").focus()
		},550)
	},[showDlg])
	React.useEffect(()=>{
		if(!uISDlglookupshow) {
			setDlglookupObj({}); return;
		}
	},[uISDlglookupshow])

	return (
		<>
		<CModal size="lg"
			alignment="center"
			visible={showDlg}
			scrollable
			{...rest}>
		<CModalHeader 
			className="bg-light text-dark py-2"
			closeButton={false}>
			<CModalTitle>
				<div className="d-none d-md-block">Form Objective</div>
				<small className="d-md-none">Form Objective</small>
			</CModalTitle>
			<CCloseButton onClick={toggleShow}/>
		</CModalHeader>

		<CModalBody>{contentMain()}</CModalBody>

		<CModalFooter>
			<MyButton
				onClick={()=>hdlKlikSimpan()}
				id="btnDialogSimpan">
				<CIcon icon="cilCheckAlt" 
				 	className="me-1 classverticalmiddle"
					height={20}/>
				{uBahasaObj.word_simpan||"Simpan"}
			</MyButton>

			<span className="me-1"/>

			<CButton color="light" onClick={toggleShow}>{uBahasaObj.word_batal||"Batal"}</CButton>
		</CModalFooter>
		</CModal>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_headers||"Lookup Data"}
			inputValue={uDlglookupObj.dlg_input||""}
			dataItemArr={uDlglookupObj.data_arr || []} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>
		</>
	)//>
}

export default MyDialogformobjective;